import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { useAlert } from "react-alert";
import { useDropzone } from "react-dropzone";
import AttachFileRoundedIcon from "@mui/icons-material/AttachFileRounded";
import { Button, Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import Switch from "@mui/material/Switch";
import { AntSwitch } from "components/UI/CustomizedComponents/CustomizedComponents";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
//import context from "../../../../../../context/auth-context";

function AiSearch(props) {
  const [checked, setChecked] = useState(props.checked);
  const [file, setFile] = useState(null);
  const [response, setResponse] = useState(null);
  const alert = useAlert();

  const [query, setQuery] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  const handleAsk =(event) => {
    event.preventDefault();
    props.handleAsk(query)
  }

  const handleChange = () => {
    if (checked) {
     console.log(checked)
      return  props.setChecked;
    } else {
      
      return  props.setChecked;
    }
  };

  return (
    <>
      <div className="col-md-4">
        <section className="container">
          <Paper
            component="form"
            sx={{ p: "4px 4px", display: "flex", alignItems: "center" }}
            fullWidth
            onSubmit={handleAsk}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Google Maps"
              inputProps={{ "aria-label": "search" }}
              value={query}
              onChange={handleInputChange}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={handleAsk}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ marginTop: "10px", marginBottom: "20px" }}
          >
            <AntSwitch
              checked={props.checked}
              // onChange={() => handleChange(checked)}
              onClick={props.handleCheck}
            />
            <Typography fontSize=".9rem">Intelligent Answer</Typography>
          </Stack>
        </section>
      </div>
    </>
  );
}
export default AiSearch;
